// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__uBtGY","footerLabel":"Footer_footerLabel__eKIhR"};